import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import MultiSelector from "./MultiSelector"
import "./LocationMultiSelector.css"
import Checkbox from "../Checkbox/Checkbox"

class LocationMultiSelector extends PureComponent {
  renderOptions = () => {
    const { handleChange, options, filters } = this.props
    if (options) {
      return options.map(o => (
        <li key={o.value}>
          <Checkbox
            label={o.label}
            id={o.label}
            onClick={() => handleChange(o, "location")}
            checked={(filters || [])?.some(f => f.value === o.value)}
          />
        </li>
      ))
    }
    return null
  }

  render() {
    const { handleChange, options, filters, ...rest } = this.props
    return (
      <div className="location-selector-wrapper">
        <MultiSelector
          text="Sijainti"
          filters={filters}
          filter="location"
          options={options}
          target="location"
          handleChange={handleChange}
          {...rest}
        >
          <ul>{this.renderOptions()}</ul>
        </MultiSelector>
      </div>
    )
  }
}

LocationMultiSelector.propTypes = {
  toggleSelector: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  clearFilters: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()),
}

export default LocationMultiSelector
